import {t} from '../../../common/getTranslations';
import {VIEWER_SETTING_THEME_TYPE_TO_COPY_MAP_FOR_LOGGING} from '../../../domain/content/[seriesId]/viewer/[productId]/constant/viewerConstant';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Icon} from '../../atoms/Icon/Icon';
import {themeSpaceItems} from './constant';
import {ViewerSettingScrollableItem} from './ViewerSettingScrollableItem';
import {ViewerSettingSpaceColorProps} from './ViewerSettingSpaceColorProps.interface';

export function ViewerSettingSpaceColor({
  isMobile,
  currentSpaceColor,
  onClickSpaceColor,
  ...props
}: ViewerSettingSpaceColorProps) {
  return (
    <ViewerSettingScrollableItem
      isMobile={isMobile}
      title={t('viewer_setting_margin')}
      gapPx={14}
      {...props}
    >
      {themeSpaceItems.map(themeItem => {
        const isSelected = themeItem.themeColor === currentSpaceColor;
        return (
          <Icon
            key={themeItem.themeColor}
            type={isSelected ? themeItem.onIconType : themeItem.offIconType}
            className="cursor-pointer"
            {...putTiaraObjectProps({
              click: {
                layer1: '뷰어설정',
                copy: VIEWER_SETTING_THEME_TYPE_TO_COPY_MAP_FOR_LOGGING[
                  themeItem.themeColor
                ],
              },
            })}
            onClick={e =>
              LOG_CLICK_EVENT('여백색_클릭', e, () => {
                onClickSpaceColor(themeItem.themeColor);
              })
            }
          />
        );
      })}
    </ViewerSettingScrollableItem>
  );
}
